export default function PHP_checkdnsrr() {
  return (
    <div>
      <h1>PHP_checkdnsrr</h1>
    </div>
  );
}
